require('./product-brands-container.scss')

module.exports = {
  template: require('./product-brands-container.pug')()
  controller: require('./product-brands-container.ctrl')
}
